export const LC_SHOW_VISION = '__lc_show_vision';

export const LC_PAGE_BEFORE_AUTH = '__lc_pba';
